import CacheByUpdatedAt from "utils/cache/CacheByUpdatedAt";
import CacheStorage from "utils/cache/CacheStorage";
import _ from "lodash";
import HelperDate, { dateFormat } from 'utils/helper-date'

export default class FetchCache {
	
	static cacheUpdatedAt = null
	static logName = 'FetchCache';
	static values = null;

	static initialize = ( owner, config, processor ) => {
		if( owner.constructing ) return owner.constructing;
		if( owner.cacheUpdatedAt !== null ) return Promise.resolve();
		owner.cacheUpdatedAt = config;
		owner.constructing = Promise.resolve()
			.then( () => {
				return FetchCache.register(config, processor);
			} )
			.catch( error => {
				owner.cacheUpdatedAt = null;
				throw error;
			} )
			.finally( () => {
				owner.constructing = null;
			} );
		return owner.constructing;
	}

	static register = async ( cacheUpdatedAt, processor ) => {
		// Register the settings table and set the max age to 5 minutes
		CacheByUpdatedAt.register( cacheUpdatedAt );

		await CacheStorage.getData( cacheUpdatedAt.identifier ).then( async results => {
			if( results !== null ) {
				if( _.get( cacheUpdatedAt, 'lastTouchAge', null ) !== null ) {
					if( results.touched_at < HelperDate.date().subtract( cacheUpdatedAt.lastTouchAge, 'seconds' ).format( dateFormat.DATE_TIME ) ) {
						await CacheStorage.removeData( cacheUpdatedAt.identifier );
						// do nothing with the code below!
						return;
					}
				}

				CacheByUpdatedAt.registerAsUpdates( {
					tables: cacheUpdatedAt.tables,
					updated_at: results.updated_at
				});
				
				processor( results.data );
			}
		});
	}

	static storeData = ( cacheUpdatedAt, data, registerUpdates ) => {
		// Get the most recent updated_at for the tables in the cache item
		let storeUpdateAt = CacheByUpdatedAt.defaultDatetime;
		_.forEach( cacheUpdatedAt.tables, table => {
			const updatedAt = CacheByUpdatedAt.getTableUpdatedAt( table )
			
			if( updatedAt > storeUpdateAt ) {
				storeUpdateAt = updatedAt;
			}
		})
		
		// Store data
		CacheStorage.storeData( cacheUpdatedAt.identifier, data, { updated_at: storeUpdateAt } );
		
		// Register
		if( registerUpdates ) {
			CacheByUpdatedAt.registerAsUpdates({
				tables: cacheUpdatedAt.tables,
				updated_at: storeUpdateAt
			});
		}
	}

	static sniff = ( cacheUpdatedAt, {onFresh = null, onExpired = null }) => {
		return CacheByUpdatedAt.sniff( {
			tables: cacheUpdatedAt.tables,
			onFresh: onFresh,
			onExpired: onExpired
		} );
	}
}
